// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/order_list_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { OrderResponse } from './parcel_create_response_pb';
import { file_responses_v1_parcel_create_response } from './parcel_create_response_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/order_list_response.proto.
 */
export const file_responses_v1_order_list_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CiZyZXNwb25zZXMvdjEvb3JkZXJfbGlzdF9yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxIrgBChFPcmRlckxpc3RSZXNwb25zZRIrCgZvcmRlcnMYASADKAsyGy5yZXNwb25zZXMudjEuT3JkZXJSZXNwb25zZRIyCgRtZXRhGAIgASgLMiQucmVzcG9uc2VzLnYxLk9yZGVyTGlzdFJlc3BvbnNlLk1ldGEaQgoETWV0YRIMCgRwYWdlGAEgASgNEg0KBWNvdW50GAIgASgNEgsKA21heBgDIAEoDRIQCghwZXJfcGFnZRgEIAEoDUKBAQoQY29tLnJlc3BvbnNlcy52MUIWT3JkZXJMaXN0UmVzcG9uc2VQcm90b1ABWgQuL3BiogIDUlhYqgIMUmVzcG9uc2VzLlYxygIMUmVzcG9uc2VzXFYx4gIYUmVzcG9uc2VzXFYxXEdQQk1ldGFkYXRh6gINUmVzcG9uc2VzOjpWMWIGcHJvdG8z',
        [file_responses_v1_parcel_create_response]
    );

/**
 * @generated from message responses.v1.OrderListResponse
 */
export type OrderListResponse = Message<'responses.v1.OrderListResponse'> & {
    /**
     * @generated from field: repeated responses.v1.OrderResponse orders = 1;
     */
    orders: OrderResponse[];

    /**
     * @generated from field: responses.v1.OrderListResponse.Meta meta = 2;
     */
    meta?: OrderListResponse_Meta | undefined;
};

/**
 * Describes the message responses.v1.OrderListResponse.
 * Use `create(OrderListResponseSchema)` to create a new message.
 */
export const OrderListResponseSchema: GenMessage<OrderListResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_order_list_response, 0);

/**
 * @generated from message responses.v1.OrderListResponse.Meta
 */
export type OrderListResponse_Meta = Message<'responses.v1.OrderListResponse.Meta'> & {
    /**
     * @generated from field: uint32 page = 1;
     */
    page: number;

    /**
     * @generated from field: uint32 count = 2;
     */
    count: number;

    /**
     * @generated from field: uint32 max = 3;
     */
    max: number;

    /**
     * @generated from field: uint32 per_page = 4;
     */
    perPage: number;
};

/**
 * Describes the message responses.v1.OrderListResponse.Meta.
 * Use `create(OrderListResponse_MetaSchema)` to create a new message.
 */
export const OrderListResponse_MetaSchema: GenMessage<OrderListResponse_Meta> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_order_list_response, 0, 0);
